import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssueTypesScreenSchemesRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-types-screen-schemes-view',
	path: '/jira/settings/issues/issue-type-screen-schemes',
};
